import { render, staticRenderFns } from "./SwitchButton.vue?vue&type=template&id=263c3c5c"
import script from "./SwitchButton.vue?vue&type=script&lang=ts"
export * from "./SwitchButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports